import BaseService from './BaseService.js';

class UserService extends BaseService {
  check(app) {
    return this.apiGet({
      url: 'profile',
      headers: {
        Application: app,
      },
    });
  }

  getRoles() {
    return this.apiGet({ url: '/roles' });
  }

  getUserPreference(data) {
    return this.apiGet({
      url: '/preference',
      data,
    });
  }

  updateUserPreference(data) {
    return this.apiPut({
      url: '/preference',
      data,
    });
  }
}

export default new UserService();
